
$(function() {  				
    $('.changeModal').on('click', function () {            					
        $('.modal-content').toggleClass('view-change');
    });
});